import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32cd6ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, " * ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 颜色 ", -1))
const _hoisted_3 = { class: "flex flex-align-center reset-input" }
const _hoisted_4 = { class: "flex flex-align-center reset-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, " * ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 货期 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.tableData,
    border: "",
    stripe: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "操作",
        width: "80px",
        align: "center"
      }, {
        default: _withCtx(({ $index }) => [
          _createVNode(_component_el_button, {
            type: "text",
            onClick: ($event: any) => (_ctx.handleRemoveRow($index))
          }, {
            default: _withCtx(() => [
              _createTextVNode("移除")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "颜色",
        "min-width": "140px",
        align: "left"
      }, {
        header: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        default: _withCtx(({ row ,$index}) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              class: "margin-top-18",
              "label-width": "0",
              prop: `tableData[${$index}].color`,
              rules: { required: true, message: '请选择颜色', trigger: ['change', 'blur'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: row.color,
                  "onUpdate:modelValue": ($event: any) => ((row.color) = $event),
                  placeholder: "选择颜色",
                  onChange: ($event: any) => (_ctx.onChangeRowColor($event, row))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suitableColorsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.color,
                        label: item.color,
                        value: item.color
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 2
            }, 1032, ["prop"])
          ])
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData[0]?.sizeQuantityList, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          "min-width": "100px",
          key: index
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_select, {
                modelValue: item.size,
                "onUpdate:modelValue": ($event: any) => ((item.size) = $event),
                placeholder: "选择尺码"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardSizeLists, (it) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: it,
                      label: it,
                      value: it,
                      disabled: _ctx.setDisabled(it)
                    }, null, 8, ["label", "value", "disabled"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_icon, {
                class: "icon-delete",
                onClick: ($event: any) => (_ctx.handleRemoveSize(index))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Delete)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_InputNumber, {
              placeholder: "数量",
              precision: 0,
              min: 0,
              modelValue: row.sizeQuantityList[index].quantity,
              "onUpdate:modelValue": ($event: any) => ((row.sizeQuantityList[index].quantity) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_el_table_column, {
        label: "合计",
        "min-width": "100px",
        align: "center"
      }, {
        default: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.getTotal(row)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "最后确认价",
        prop: "confirmPrice",
        "min-width": "120px",
        align: "center"
      }),
      _createVNode(_component_el_table_column, {
        label: "货期",
        "min-width": "160px",
        align: "left"
      }, {
        header: _withCtx(() => [
          _hoisted_5,
          _hoisted_6
        ]),
        default: _withCtx(({ row, $index }) => [
          _createVNode(_component_el_form_item, {
            "label-width": "0",
            prop: `tableData[${$index}].deliveryDate`,
            rules: { required: true, message: '请选择货期', trigger: ['change', 'blur'] },
            class: "margin-top-18"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: row.deliveryDate,
                "onUpdate:modelValue": ($event: any) => ((row.deliveryDate) = $event),
                type: "date",
                placeholder: "选择日期",
                style: {"width":"140px"},
                onChange: ($event: any) => (_ctx.handleDateChange($event, row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 2
          }, 1032, ["prop"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "客户批次",
        "min-width": "100px"
      }, {
        default: _withCtx(({ row }) => [
          _createVNode(_component_el_input, {
            modelValue: row.purchaserBatch,
            "onUpdate:modelValue": ($event: any) => ((row.purchaserBatch) = $event),
            maxlength: 30
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "备注",
        "min-width": "160px",
        align: "center"
      }, {
        default: _withCtx(({ row }) => [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: row.remark,
            "onUpdate:modelValue": ($event: any) => ((row.remark) = $event),
            placeholder: "限100字符",
            "show-word-limit": true,
            maxLength: "100"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}